module.exports = __webpack_public_path__ + "1791188489487/fonts/Flaticon.122c478.eot";